import { motion } from "framer-motion";
import ServiceNavigation from "./ServiceNavigation";
const pageVariants = {
  initial: { opacity: 0, rotateY: 8 },
  animate: { opacity: 1, rotateY: 0 },
  exit: { opacity: 0, rotateY: -8 },
};
const images = [
  "/f 2.jpeg",
  "/f 3.jpeg",
  "/f 1.jpeg",
  "/f 4.jpeg",
  "/f 5.jpeg",
  "/f 6.jpeg",
];
const dripsColors = [
  "#7c5cbf",
  "#c9982a",
  "#2a7abf",
  "#0ab5a8",
  "#d6246e",
  "#e8503a",
  "#7c5cbf",
];
const dripsHeights = [60, 80, 50, 90, 65, 75, 55];
const grad = "linear-gradient(135deg,#7c5cbf,#b090e0)";
const color = "#7c5cbf";
function Largecanvas() {
  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.6, ease: "easeInOut" }}
    >
      <section
        style={{
          minHeight: "55vh",
          background:
            "linear-gradient(150deg,#0f0520 0%,#1a0a2e 35%,#180a28 70%,#0a1828 100%)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          padding: "100px 5% 60px",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {[
          {
            size: 350,
            color: "#7c5cbf",
            top: "-100px",
            left: "-80px",
            delay: 0,
          },
          {
            size: 250,
            color: "#2a7abf",
            bottom: "-60px",
            right: "-60px",
            delay: 1.5,
          },
          { size: 180, color: "#e8503a", top: "30%", right: "8%", delay: 3 },
        ].map((b, i) => (
          <motion.div
            key={i}
            animate={{
              scale: [1, 1.2, 1],
              rotate: [0, 20, 0],
              opacity: [0.6, 0.9, 0.6],
            }}
            transition={{
              repeat: Infinity,
              duration: 6,
              delay: b.delay,
              ease: "easeInOut",
            }}
            style={{
              position: "absolute",
              width: b.size,
              height: b.size,
              borderRadius: "50%",
              background: `radial-gradient(circle,${b.color},transparent 70%)`,
              top: b.top,
              bottom: b.bottom,
              left: b.left,
              right: b.right,
              pointerEvents: "none",
              mixBlendMode: "screen",
            }}
          />
        ))}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          style={{
            fontFamily: "'Satisfy',cursive",
            color: "#c9982a",
            fontSize: "1.1rem",
            letterSpacing: "3px",
            marginBottom: 16,
          }}
        >
          ✦ Fine Art Service ✦
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.9 }}
          style={{
            fontFamily: "'Cormorant Garamond',serif",
            fontSize: "clamp(2.8rem,7vw,5rem)",
            fontWeight: 700,
            fontStyle: "italic",
            color: "#fff",
            lineHeight: 1.1,
          }}
        >
          Large <span style={{ color: "#c9982a" }}>Canvas</span>
        </motion.h1>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          style={{
            color: "rgba(255,255,255,.6)",
            fontWeight: 300,
            fontSize: "1.05rem",
            maxWidth: 500,
            margin: "18px auto 0",
            lineHeight: 1.9,
          }}
        >
          Monumental canvas paintings that command attention. Custom large-scale
          artwork for corporate spaces, luxury residences, and galleries.
        </motion.p>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          style={{
            display: "flex",
            justifyContent: "center",
            gap: 6,
            marginTop: 40,
          }}
        >
          {dripsColors.map((c, i) => (
            <motion.div
              key={i}
              animate={{ scaleY: [1, 1.15, 1], y: [0, 4, 0] }}
              transition={{
                repeat: Infinity,
                duration: 2,
                delay: i * 0.2,
                ease: "easeInOut",
              }}
              style={{
                width: 10,
                height: dripsHeights[i],
                borderRadius: 40,
                background: c,
                transformOrigin: "top",
              }}
            />
          ))}
        </motion.div>
      </section>
      <section style={{ padding: "80px 5%", background: "#fff" }}>
        <div style={{ maxWidth: 800, margin: "0 auto" }}>
          <span
            style={{
              display: "inline-block",
              padding: "5px 16px",
              borderRadius: 20,
              background: grad,
              color: "#fff",
              fontSize: ".7rem",
              fontWeight: 700,
              letterSpacing: "1.5px",
              textTransform: "uppercase",
              marginBottom: 20,
            }}
          >
            Fine Art
          </span>
          <h2
            style={{
              fontFamily: "'Cormorant Garamond',serif",
              fontSize: "clamp(1.8rem,4vw,2.6rem)",
              fontWeight: 700,
              color: "#1a0a1e",
              marginBottom: 6,
              display: "flex",
              alignItems: "center",
              gap: 10,
            }}
          >
            <span>🖼️</span> Large Canvas
          </h2>
          <div
            style={{
              height: 4,
              width: 60,
              borderRadius: 3,
              background: grad,
              margin: "14px 0 24px",
            }}
          />
          <p
            style={{
              color: "#4a3a5a",
              lineHeight: 1.95,
              fontSize: "1.05rem",
              fontWeight: 300,
              marginBottom: 32,
            }}
          >
            Large Canvas paintings are the ultimate statement piece for any
            space. We create custom oversized artworks — hand-painted on premium
            stretched canvas — tailored to the exact dimensions, colour palette,
            and mood of your environment. Our artists bring fine art mastery to
            every piece, whether it's an abstract expressionist work, a
            botanical panorama, or a portrait commission. Each canvas is sealed,
            framed, and delivered installation-ready.
          </p>
          <motion.a
            href="https://wa.me/916383283731/?text=I%20Want%20to%20Enquire%20about%20the%20Large%20Canvas"
            whileHover={{ y: -3 }}
            style={{
              display: "inline-block",
              padding: "13px 36px",
              borderRadius: 50,
              background: grad,
              color: "#fff",
              fontWeight: 700,
              fontSize: ".95rem",
              textDecoration: "none",
              fontFamily: "'DM Sans',sans-serif",
              letterSpacing: ".5px",
              boxShadow: `0 8px 28px ${color}44`,
            }}
          >
            Enquire About This Service →
          </motion.a>
        </div>
      </section>
      <section
        style={{ padding: "80px 4%", background: "var(--cream,#fdf8f0)" }}
      >
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            style={{
              fontFamily: "'Cormorant Garamond',serif",
              fontSize: "clamp(2rem,4vw,3rem)",
              fontWeight: 700,
              fontStyle: "italic",
              color: "#1a0a1e",
              textAlign: "center",
              marginBottom: 12,
            }}
          >
            Our <span style={{ color }}>Large Canvas</span> Work
          </motion.h2>
          <motion.div
            initial={{ scaleX: 0 }}
            whileInView={{ scaleX: 1 }}
            viewport={{ once: true }}
            style={{
              height: 4,
              width: 80,
              borderRadius: 3,
              background: grad,
              margin: "0 auto 50px",
            }}
          />
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit,minmax(300px,1fr))",
              gap: 20,
            }}
          >
            {images.map((src, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1, duration: 0.6 }}
                whileHover={{
                  y: -8,
                  boxShadow: "0 20px 50px rgba(0,0,0,0.18)",
                }}
                style={{
                  borderRadius: 20,
                  overflow: "hidden",
                  boxShadow: "0 6px 24px rgba(0,0,0,0.1)",
                  background: "#fff",
                }}
              >
                <img
                  src={src}
                  alt={`Large Canvas ${i + 1}`}
                  style={{
                    width: "100%",
                    height: 260,
                    objectFit: "cover",
                    display: "block",
                  }}
                />
              </motion.div>
            ))}
          </div>
        </div>
      </section>
      <ServiceNavigation
        prevLink="/services/wall-sculptures"
        prevTitle="Wall Sculptures"
        nextLink="/services/home-decors"
        nextTitle="Home Decors"
      />
    </motion.div>
  );
}
export default Largecanvas;
